(() => {
  const finish = () => {
    const relatedLink = document.querySelector('.vv-product-related__head > a');
    if (relatedLink && /^View all\s+\d+/i.test(relatedLink.textContent.trim())) {
      relatedLink.textContent = 'View Chapter I →';
      relatedLink.setAttribute('aria-label', 'View Chapter I');
    }

    document.querySelectorAll('.vv-product-assurance').forEach((el) => {
      if (/30-day support window/i.test(el.textContent)) {
        el.textContent = 'Post-delivery support · secure checkout';
      }
    });

    document.querySelectorAll('.shopify-policy__body').forEach((body) => {
      const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach((node) => {
        if (/hello@artivanaarchive\.com/i.test(node.nodeValue || '')) {
          node.nodeValue = node.nodeValue.replace(/hello@artivanaarchive\.com/gi, 'our Contact page');
        }
      });
      body.querySelectorAll('a[href^="mailto:hello@artivanaarchive.com"]').forEach((link) => {
        link.setAttribute('href', '/pages/contact');
        link.textContent = 'our Contact page';
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', finish, { once: true });
  else finish();
})();
